'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DataRetriever', 'AVRO.Common.Moment', 'AVRO.SystemConfiguration.Panel', 'AVRO.Rules.CommonServices'];
module.exports = angular.module('AVRO.SystemStatus.History', dependencies).controller('SystemStatusHistoryController', require('./controllers/SystemStatusHistoryController')).directive('rmSystemStatusHistory', require('./directives/SystemStatusHistoryDirective'));